





import Vue from 'vue'

export default Vue.extend({
  name: 'UniqueCellRenderer',

  computed: {
    icon (): string {
      // @ts-ignore
      return this.params.data.isUnique ? 'check' : 'clear'
    },

    color (): string {
      // @ts-ignore
      return this.params.data.isUnique ? 'green' : 'red'
    }
  }
})
